import React, { useState, useEffect, useLayoutEffect } from 'react';
import useStore from '@/store/store';
import ChangeFeeModal from '../change-fee-modal/ChangeFeeModal';
import ChangeAreaModal from '../change-area-modal/ChangeAreaModal';
import Button from '@/ui/button/Button';
import { toast } from 'react-hot-toast';
import OrderController from '@/services/OrderController';
import s from './order.module.css';

const Order = ({ order, onDeleteOrder, withFees, withShopFees, onPiecesChanged }) => {
	console.log(order);

	const [assigned, setAssigned] = useState(null);
	const [minDif1, setMinDif1] = useState(null);
	const [carried, setCarried] = useState(null);
	const [minDif2, setMinDif2] = useState(null);

	const { user } = useStore();

	const [completed, setCompleted] = useState(null);

	const [changeFeeModalVisible, setChangeFeeModalVisible] = useState(false);
	const [changeShopFeeModalVisible, setChangeShopFeeModalVisible] = useState(false);
	const [changeAreaModalVisible, setChangeAreaModalVisible] = useState(false);
	// Piece work (envelopes, newspapers): the admin's correction of the pieces.
	// null = not editing; otherwise the number as typed.
	const [piecesDraft, setPiecesDraft] = useState(null);
	const [savingPieces, setSavingPieces] = useState(false);

	// const date = new Date(order?.originalOrderCreatedAt || order?.createdAt);

	// let displayFrom = date;
	// let yyyy = displayFrom.getFullYear();
	// let mm = displayFrom.getMonth() + 1;
	// let dd = displayFrom.getDate();

	// if (dd < 10) dd = '0' + dd;
	// if (mm < 10) mm = '0' + mm;

	// displayFrom =
	// 	dd +
	// 	'/' +
	// 	mm +
	// 	'/' +
	// 	yyyy +
	// 	' - ' +
	// 	date.getHours() +
	// 	':' +
	// 	`${date.getMinutes() < 10 ? '0' : ''}${date.getMinutes()}`;

	function getMinDiff(startDate, endDate) {
		// const value = Math.round((Math.abs(endDate - startDate) / 60) * 1000);
		//  const msInMinute = 60 * 1000;

		return Math.round(Math.abs(endDate - startDate) / (60 * 1000));
		// return value;
	}

	useLayoutEffect(() => {
		if (!order) {
			return undefined;
		}
		let date = new Date(order?.aAt);
		let minutes = date.getMinutes();
		setAssigned(!order?.aAt ? '-' : date.getHours() + ':' + `${minutes < 10 ? '0' : ''}${minutes}`);

		let minDif;
		if (order.cAt) {
			minDif = getMinDiff(new Date(order?.aAt), new Date(order?.cAt));

			date = new Date(order?.cAt);
			minutes = date.getMinutes();
			setCarried(date.getHours() + ':' + `${minutes < 10 ? '0' : ''}${minutes}`);

			setMinDif1(minDif);

			minDif = getMinDiff(new Date(order?.cAt), new Date(order?.createdAt));
			setMinDif2(minDif);
		} else {
			setCarried('-');
		}

		date = new Date(order?.createdAt);
		minutes = date.getMinutes();

		setCompleted(date.getHours() + ':' + `${minutes < 10 ? '0' : ''}${minutes}`);
	}, [order]);

	if (!order) {
		return null;
	}

	// A job paid by the piece: the server sends its pieces (pcs) and, to those
	// who may see money, the price per piece (pp).
	const isPieceWork =
		(order.pp !== undefined && order.pp !== null) ||
		(order.pcs !== undefined && order.pcs !== null);

	const savePieces = async () => {
		const n = Number(piecesDraft);
		if (!Number.isInteger(n) || n < 0) {
			toast.error('Γράψτε έναν ακέραιο αριθμό τεμαχίων');
			return;
		}
		setSavingPieces(true);
		const res = await OrderController.updateCompletedOrderPieces(order.id, n);
		setSavingPieces(false);
		if (res?.error) {
			toast.error(typeof res.error === 'string' ? res.error : 'Κάποιο πρόβλημα προέκυψε');
			return;
		}
		toast.success('Τα τεμάχια άλλαξαν');
		setPiecesDraft(null);
		onPiecesChanged?.(res.pieces, res.shopFee);
	};

	return (
		<div className={s.container}>
			{changeFeeModalVisible ? (
				<ChangeFeeModal order={order} onClose={() => setChangeFeeModalVisible(false)} />
			) : changeShopFeeModalVisible ? (
				<ChangeFeeModal
					order={order}
					mode='shopFee'
					onClose={() => setChangeShopFeeModalVisible(false)}
				/>
			) : changeAreaModalVisible ? (
				<ChangeAreaModal
					order={order}
					withFees={withFees}
					withShopFees={withShopFees}
					onClose={() => setChangeAreaModalVisible(false)}
				/>
			) : (
				<>
					{/* <div className='modal-title'>{displayFrom}</div> */}

					{/* <div className='modal-title-line' /> */}

					<div className=''>
						<div className={s.labelContainer}>
							<div className={s.label}>Αποδοχή</div>

							<div className={s.value}>{assigned}</div>
						</div>

						{minDif1 && (
							<div className={s.difContainer}>
								<div className={s.dashedLine} />
								<div className={s.difText}>{`${minDif1}'`}</div>
							</div>
						)}

						<div className={s.labelContainer}>
							<div className={s.label}>Παραλαβή</div>

							<div className={s.value}>{carried}</div>
						</div>
						{minDif2 && (
							<div className={s.difContainer}>
								<div className={s.dashedLine} />
								<div className={s.difText}>{`${minDif2}'`}</div>
							</div>
						)}

						<div className={s.labelContainer}>
							<div className={s.label}>Ολοκλήρωση</div>

							<div className={s.value}>{completed}</div>
						</div>
						<div className={s.labelContainer}>
							<div className={s.label}>Διανομέας</div>

							<div className={s.value}>{order.d?.name || '-'}</div>
						</div>

						{isPieceWork && (
							<div className={s.labelContainer}>
								<div className={s.label}>Τεμάχια</div>

								<div className={s.value}>{order.pcs ?? '-'}</div>
							</div>
						)}

						<div className={s.labelContainer}>
							<div className={s.label}>Χλμ</div>

							<div className={s.value}>{`${
								order.distanceMeters ? order.distanceMeters / 1000 : '-'
							}`}</div>
						</div>

						{(user?.role === 'admin' || user?.role === 'master') && (
							<div className='flex flex-col items-center gap-y-0'>
								{user.cityLocation?.areas?.length > 0 && (
									<Button
										text='Αλλαγή περιοχής'
										onClick={() => setChangeAreaModalVisible(true)}
										styleStyle={{ width: 250, maxWidth: 250 }}
									/>
								)}
								{withFees && (
									<Button
										text='Αλλαγή προμήθειας'
										onClick={() => setChangeFeeModalVisible(true)}
										styleStyle={{ width: 250, maxWidth: 250 }}
									/>
								)}
								{isPieceWork &&
									(piecesDraft === null ? (
										<Button
											text='Αλλαγή τεμαχίων'
											onClick={() => setPiecesDraft(`${order.pcs ?? ''}`)}
											styleStyle={{ width: 250, maxWidth: 250 }}
										/>
									) : (
										<div className='my-2 flex items-center gap-2'>
											<input
												type='number'
												min='0'
												step='1'
												inputMode='numeric'
												value={piecesDraft}
												onChange={e => setPiecesDraft(e.target.value)}
												className='h-10 w-28 rounded-md border border-slate-300 px-2 text-[15px]'
												aria-label='Τεμάχια'
												autoFocus
											/>
											<button
												type='button'
												disabled={savingPieces}
												onClick={savePieces}
												className='h-10 rounded-md bg-[#0f9b9d] px-4 text-[14px] text-white disabled:opacity-50'
											>
												Αποθήκευση
											</button>
											<button
												type='button'
												onClick={() => setPiecesDraft(null)}
												className='h-10 px-2 text-[14px] text-slate-500'
											>
												Άκυρο
											</button>
										</div>
									))}
								{withShopFees && (
									<Button
										text='Αλλαγή χρέωσης καταστ.'
										onClick={() => setChangeShopFeeModalVisible(true)}
										styleStyle={{ width: 250, maxWidth: 250 }}
									/>
								)}
								{/* {order?.deliveredBy === 'wolt' ? (
									<Button
										text='Wolt data'
										onClick={() => setPage('wolt')}
										// disabled={saveDisabled}
										extraStyle={s.saveButton}
										extraTextStyle={s.saveButtonText}
									/>
								) : null} */}
								<div
									className='mt-5 cursor-pointer self-center !text-[rgba(255,0,0,0.8)]'
									onClick={onDeleteOrder}
								>
									Διαγραφή παραγγελίας
								</div>
							</div>
						)}
					</div>
				</>
			)}
		</div>
	);
};

export default Order;
